import { render } from "./wokerDetail13.vue?vue&type=template&id=0c766351&scoped=true"
import script from "./wokerDetail13.vue?vue&type=script&lang=js"
export * from "./wokerDetail13.vue?vue&type=script&lang=js"

import "./wokerDetail13.vue?vue&type=style&index=0&id=0c766351&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c766351"]])

export default __exports__